export interface AdvertViewVehicleProvenanceDTO {
  finance: boolean;
  scrapped: boolean;
  stolen: boolean;
}
